module.exports.baseUrl = (uri) => {
    return location.origin + '/' + uri.replace(/^\//, '');
}

module.exports.apiBaseUrl = (uri) => {
    return process.env.API_URL.replace(/\/$/, '') + '/' + uri.replace(/^\//, '');
}

module.exports.isApiBaseUrl = (url) => {
    return process.env.API_URL.replace(/\/$/, '') == url
}



// WEBPACK FOOTER //
// ./src/lib/util.js